import React, { useCallback } from 'react';

import { Visibility, VisibilityOff } from '@mui/icons-material';

import RadioButtonGroup from 'components/RadioButton/RadioButtonGroup';
import RichText from 'components/RichText/RichText';

import {
  CheckoutDesignTabProps,
  PREVIEW_MODE_OPTIONS,
  PRODUCTS_PREVIEW_OPTIONS,
  WALLETS
} from '../types';

const CheckoutDisplayTab: React.FC<CheckoutDesignTabProps> = ({
  formikProps
}) => {
  const { values, setFieldValue } = formikProps;

  const handleProductListChange = useCallback(
    (val: string) => setFieldValue('expandProductList', val === 'Expand'),
    [setFieldValue]
  );

  const handleAPMsChange = useCallback(
    (val: string) => setFieldValue('filterAPMs', val === 'Visible'),
    [setFieldValue]
  );

  const toggleWalletVisibility = useCallback(
    (walletKey: string, isVisible: boolean) => {
      if (isVisible) {
        setFieldValue(
          'filterWallets',
          values.filterWallets.filter((key: string) => key !== walletKey)
        );
      } else {
        setFieldValue('filterWallets', [...values.filterWallets, walletKey]);
      }
    },
    [setFieldValue, values.filterWallets]
  );

  const renderWalletItem = (wallet: { key: string; label: string }) => {
    const isVisible = values.filterWallets.includes(wallet.key);

    return (
      <div
        key={wallet.key}
        className={`flex items-center gap-2 ${isVisible ? '' : 'opacity-50'}`}
      >
        <div
          onClick={() => toggleWalletVisibility(wallet.key, isVisible)}
          className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-md cursor-pointer"
        >
          {isVisible ? (
            <Visibility style={{ color: 'black' }} />
          ) : (
            <VisibilityOff style={{ color: 'black' }} />
          )}
        </div>
        <span className="text-sm">{wallet.label}</span>
      </div>
    );
  };

  return (
    <div className="w-[456px] mx-auto">
      <RichText
        title="Checkout Display"
        description="Customize your checkout display"
        className="mb-9"
      />

      <p className="text-p-l font-medium my-3">Products Preview:</p>
      <RadioButtonGroup
        value={values.expandProductList ? 'Expand' : 'Collapse'}
        onValueChange={handleProductListChange}
        className="border-r border-base-border h-6 pr-7"
        options={PRODUCTS_PREVIEW_OPTIONS}
      />

      <p className="text-p-l font-medium mt-8 mb-3">Express buttons:</p>
      <div className="grid grid-cols-2 gap-4 mb-6">
        {WALLETS.map(renderWalletItem)}
      </div>

      <p className="text-p-l font-medium mt-8 mb-3">APMS - Preview Mode:</p>
      <RadioButtonGroup
        value={values.filterAPMs ? 'Visible' : 'Hidden'}
        onValueChange={handleAPMsChange}
        className="border-r border-base-border h-6 pr-7 mb-9"
        options={PREVIEW_MODE_OPTIONS}
      />
    </div>
  );
};

export default CheckoutDisplayTab;
